import { Box, Link, Skeleton, Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { capitalize } from 'lodash';
import React from 'react';

import MBreadcrumbs from 'components/@material-extend/MBreadcrumbs/MBreadcrumbs';

import useLocales from 'hooks/useLocales';

// TODO: Extract to a separate file
interface Link {
    href: string;
    name?: string;
    icon?: string;
}

interface HeaderBreadcrumbsProps {
    links?: Link[];
    action?: React.ReactChild;
    lesson?: number;
    heading?: string;
    moreLink?: string | string[];
    sx?: SxProps<Theme>;
}

const HeaderBreadcrumbs: React.FunctionComponent<HeaderBreadcrumbsProps> = ({
    links,
    action,
    lesson,
    heading,
    moreLink = '' || [],
    sx,
    ...other
}) => {
    const { translate } = useLocales();

    return (
        <Box sx={{ mb: 5, ...sx }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ flexGrow: 1 }}>
                    {lesson !== undefined && (
                        <Typography variant='subtitle2'>
                            {translate('lesson')} {lesson}
                        </Typography>
                    )}
                    <Typography variant='h3' gutterBottom>
                        {heading ? capitalize(heading) : <Skeleton width='40%' />}
                    </Typography>
                    {links && <MBreadcrumbs links={links} {...other} />}
                </Box>

                {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
            </Box>

            <Box sx={{ mt: 2 }}>
                {typeof moreLink === 'string' ? (
                    <Link href={moreLink} target='_blank' variant='body2'>
                        {moreLink}
                    </Link>
                ) : (
                    moreLink.map(href => (
                        <Link noWrap key={href} href={href} variant='body2' target='_blank' sx={{ display: 'table' }}>
                            {href}
                        </Link>
                    ))
                )}
            </Box>
        </Box>
    );
};

export default HeaderBreadcrumbs;
